import React from 'react'

const ActionBar = ({ children, active }) => {
  return (
    <div className={`ActionBar ${active && 'active'}`}>
      <div>{children}</div>
    </div>
  )
}

export default ActionBar
